import { render, staticRenderFns } from "./QrScan.vue?vue&type=template&id=21dadd99&scoped=true"
import script from "./QrScan.vue?vue&type=script&lang=ts"
export * from "./QrScan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dadd99",
  null
  
)

export default component.exports